export const LANGUAGE_CONSTANTS_KEY = {
  'Privacy Policy': 'Privacy_Policy',
  Back: 'Back',
  'Hi, welcome to Sense!': 'Hi_welcome_to_Sense',
  'Enter the email address associated with your account and we\'ll send you a link to reset your password.':
    'Enter_the_email_address_associated_with_your_account_and_we\'ll_send_you_a_link_to_reset_your_password',
  'Please check your email for a password reset link.':
    'Please_check_your_email_for_a_password_reset_link',
  'You will receive an email with a link to reset your password if you have entered an email that matches your account. Please check spam or junk folders as well.':
    'You_will_receive_an_email_with_a_link_to_reset_your_password_if_you_have_entered_an_email_that_matches_your_account_Please_check_spam_or_junk_folders_as_well',
  'Create new password': 'Create_new_password',
  'To secure your account, make sure your password includes:':
    'To_secure_your_account_make_sure_your_password_includes',
  'Please enter a valid email address': 'Please_enter_a_valid_email_address',
  'Name is mandatory': 'Name_is_mandatory',
  'Password is mandatory': 'Password_is_mandatory',
  'Multifactor authentication': 'Multifactor_authentication',
  'Your organization has enabled multifactor authentication for added security. To receive your verification code, please enter your personal mobile phone number.':
    'Your_organization_has_enabled_multifactor_authentication_for_added_security_To_receive_your_verification_code_please_enter_your_personal_mobile_phone_number',
  'A verification code has been sent to your phone number':
    'A_verification_code_has_been_sent_to_your_phone_number',
  'Your organization has enabled multifactor authentication for added security. The verification code has been sent to your registered email.':
    'Your_organization_has_enabled_multifactor_authentication_for_added_security_The_verification_code_has_been_sent_to_your_registered_email',
  'Pending admin approval.': 'Pending_admin_approval',
  'Verification code has been resent': 'Verification_code_has_been_resent',
  'An email with a link to reset your phone number has been sent to your administrator for approval.':
    'An_email_with_a_link_to_reset_your_phone_number_has_been_sent_to_your_administrator_for_approval',
  'Please select your account.': 'Please_select_your_account',
  'Reset password': 'Reset_password',
  'At least 12 characters (required for your password)—the more characters, the better':
    'At_least_12_characters_required_for_your_passwordthe_more_characters_the_better',
  'At least one uppercase and lowercase letter':
    'At_least_one_uppercase_and_lowercase_letter',
  'At least one number': 'At_least_one_number',
  'At least one special character, e.g., ! @ # ? ]':
    'At_least_one_special_character_eg_',
  'Invalid Reset Token or User Not Logged In':
    'Invalid_Reset_Token_or_User_Not_Logged_In',
  'Enter the below details to sign up.': 'Enter_the_below_details_to_sign_up',
  'Password has been reset': 'Password_has_been_reset',
  'You can now access your account using your new password.':
    'You_can_now_access_your_account_using_your_new_password',
  'The Sense Talent Engagement Platform':
    'The_Sense_Talent_Engagement_Platform',
  'Accelerate hiring, strengthen your brand, and exceed recruiting targets - all while delivering a personalized candidate experience.':
    'Accelerate_hiring_strengthen_your_brand_and_exceed_recruiting_targets_all_while_delivering_a_personalized_candidate_experience',
} as const;

export const CONSTANTS = {
  PRIVACY_POLICY_LINK: 'https://www.sensehq.com/privacy-policy',
  PRIVACY_POLICY_TEXT: 'Privacy Policy',
  BACK_BUTTON_TEXT: 'Back',
  SIGNIN_TITLE: 'Hi, welcome to Sense!',
  INVALID_EMAIL: 'Please enter a valid email address',
  INVALID_FULL_NAME: 'Name is mandatory',
  EMPTY_PASSWORD: 'Password is mandatory',
  PHONE_REGISTARTION_TITLE: 'Multifactor authentication',
  PHONE_REGISTARTION_SUBTEXT:
    'Your organization has enabled multifactor authentication for added security. To receive your verification code, please enter your personal mobile phone number.',
  OTP_PAGE_TITLE: 'Multifactor authentication',
  OTP_PAGE_SUBTEXT: 'A verification code has been sent to your phone number',
  EMAIL_OTP_PAGE_SUBTEXT:
    'Your organization has enabled multifactor authentication for added security. The verification code has been sent to your registered email.',
  PHONE_RESET_TITLE: 'Pending admin approval.',
  RESEND_OTP_SUCCESS: 'Verification code has been resent',
  PHONE_RESET_SUBTEXT:
    'An email with a link to reset your phone number has been sent to your administrator for approval.',
  DYNAMIC_AGENCY_TITLE: 'Hi, welcome to Sense!',
  DYNAMIC_AGENCY_SUBTEXT: 'Please select your account.',
  RESET_PASSWORD_TITLE: 'Reset password',
  RESET_PASSWORD_SUBTEXT:
    'Enter the email address associated with your account and we\'ll send you a link to reset your password.',
  FORGOT_PASSWORD_CONFIRMATION_TITLE:
    'Please check your email for a password reset link.',
  FORGOT_PASSWORD_CONFIRMATION_SUBTEXT:
    'You will receive an email with a link to reset your password if you have entered an email that matches your account. Please check spam or junk folders as well.',
  RESET_PASSWORD_PAGE_TITLE: 'Create new password',
  PASSWORD_INSRUCTION_TEXT:
    'To secure your account, make sure your password includes:',
  PASSWORD_INS_1:
    'At least 12 characters (required for your password)—the more characters, the better',
  PASSWORD_INS_2: 'At least one uppercase and lowercase letter',
  PASSWORD_INS_3: 'At least one number',
  PASSWORD_INS_4: 'At least one special character, e.g., ! @ # ? ]',
  RESET_PASSWORD_DISABLED_ALERT: 'Invalid Reset Token or User Not Logged In',
  SIGNUP_TITLE: 'Hi, welcome to Sense!',
  SIGNUP_SUBTEXT: 'Enter the below details to sign up.',
  RESET_PASSWORD_CONFIRMATION_TITLE: 'Password has been reset',
  RESET_PASSWORD_CONFIRMATION_SUBTEXT:
    'You can now access your account using your new password.',
  BRANDING_PAGE_HEADER: 'The Sense Talent Engagement Platform',
  BRANDING_PAGE_SUBTEXT:
    'Accelerate hiring, strengthen your brand, and exceed recruiting targets - all while delivering a personalized candidate experience.',
} as const;

export const getTranslatedText = (
  t: (key: string, text: string) => string,
  text: string,
): string => {
  // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly 'Privacy Policy': "Privacy_Policy"; readonly Back: "Back"; readonly 'Hi, welcome to Sense!': "Hi_welcome_to_Sense"; readonly 'Enter the email address associated with your account and we\'ll send you a link to reset your password.': "Enter_the_email_address_associated_with_your_account_and_we'll_send_you_a...'.
  const key = LANGUAGE_CONSTANTS_KEY[text];
  if (key) {
    return t(key, text);
  }
  return text;
};

export const ALLOWED_COUNTRY_CODES = [
  'US',
  'GB',
  'AU',
  'HK',
  'MY',
  'SG',
  'DE',
  'BE',
  'NZ',
  'IN',
] as const;
